import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { showDialog } from "@widgets/CommonDialog";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";

interface popupProps {
  /** 본화면 조회조건(기준주차/담당자/업무영역) — 이전 주차 계산은 서버(pop_01_01)에서 한다. */
  searchData?: any;
  modalRef?: any;
}

const SN_SFA_JOURNAL_REG_001_POP_01 = forwardRef(
  ({ searchData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const gridRef = useRef<SnGridRef>(null);
    const [columns, setColumns] = useState<any[]>([]);
    const [dataSource, setDataSource] = useState<any[]>([]);

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        const checkedRows = gridRef.current?.getCheckedRows?.() ?? [];
        if (!checkedRows.length) {
          await showDialog("alter", "가져올 계획을 선택하세요.");
          return false;
        }
        return true;
      },
      getOkayData: () => ({
        rtnData: [gridRef.current?.getCheckedRows?.() ?? []],
      }),
    }));

    useEffect(() => {
      const fetchData = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_SFA_JOURNAL_REG_001_POP_01",
            {}
          );
          setColumns(rtn.grid?.grid1 ?? []);

          // 주차는 조회조건 그대로 넘긴다. 직전 주 계산(-7일)은 pop_01_01 쿼리가 한다.
          // 여기서 한 번 더 빼면 2주 전을 보게 되고, 1주차에서는 '00' 주차가 되어 아예 깨진다.
          const data: any = await fnGetDataSet({
            id: "sn_sfa_journal_reg_001_pop_01_01",
            params: { ...(searchData ?? {}) },
          });
          const rows: any[] = data?.[0] ?? [];
          setDataSource(rows);
          if (!rows.length) {
            await showDialog("alter", "등록된 전주 계획이 없습니다.");
          }
        } catch (error) {}
      };
      fetchData();
    }, [searchData]);

    return (
      <div style={{ height: "55vh" }}>
        <SnGrid
          ref={gridRef}
          columnConfig={columns}
          rowData={dataSource}
          etcProps={{
            rowSelection: "multiple",
            isEditable: false,
            ischeckboxSelection: true,
            popupParent: modalRef?.current?.getPopupParent?.(),
          }}
        />
      </div>
    );
  }
);

export default SN_SFA_JOURNAL_REG_001_POP_01;
